import common from './common.json';

const com = { common };

export default com;
